module.exports = __webpack_public_path__ + "img/loginlogo.f1a518f4.png";